module.exports = __webpack_public_path__ + "img/book-orbit.81900be5.png";